export function getEnumValue<T extends Record<string, string | number>>(
  enumObj: T,
  value: string,
  defaultValue?: T[keyof T],
): T[keyof T] {
  const enumInstance = (
    Object.values(enumObj) as Array<string | number>
  ).includes(value)
    ? (value as T[keyof T])
    : undefined;
  if (enumInstance === undefined) {
    if (defaultValue) {
      return defaultValue;
    } else {
      throw new Error(
        `Invalid enum value: ${value} for enum ${JSON.stringify(enumObj)}`,
      );
    }
  }
  return enumInstance;
}
